<template>
  <div class="container-fluid">
    <div class="loading" v-if="loading">Loading&hellip;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Cuenta corriente — {{ provider !== null ? provider.name : '...' }}</h1>
          <p v-if="provider !== null" class="view-header__subtitle">
            <span v-if="provider.business">{{ provider.business }}</span>
            <span v-if="provider.address"> · {{ provider.address }}</span>
            <span v-if="provider.phone_1"> · Tel. {{ provider.phone_1 }}</span>
          </p>
        </div>
        <div class="view-header__actions">
          <button type="button" class="btn view-header__btn" @click="ccProveedoresLink">
            <i class="bi bi-arrow-left"></i>
            Volver
          </button>
          <button type="button" class="btn view-header__btn" @click="exportPDF()">
            <i class="bi bi-download"></i>
            Exportar PDF
          </button>
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="showPaseModal = true">
            <i class="bi bi-plus-lg"></i>
            Nuevo pase a cuenta
          </button>
        </div>
      </div>
    </div>

    <!-- BALANCE -->
    <div class="stats-card">
      <div class="stats-card__value">{{ formatoDinamicoMoneda(balance) }}</div>
      <div class="stats-card__label">Saldo actual de cuenta corriente</div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <q-select v-model.number="filters.type" :options="typeFilterOptions" />
          </div>
          <div class="filters-panel__field">
            <Daterange :opendir="'left'" :filtered="true" @datepicked="dateUpdated"/>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <div class="table-responsive">
        <table class="table mb-0">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Vencimiento</th>
              <th>Comprobante</th>
              <th>Concepto</th>
              <th class="text-right">Debe</th>
              <th class="text-right">Haber</th>
              <th class="text-right">Saldo</th>
              <th class="text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cc in accounts" :key="cc.id">
              <td>{{ cc.created_at }}</td>
              <td>{{ cc.duedate || '-' }}</td>
              <td>
                <a v-if="cc.menu !== null && cc.menu['type'] === 'purchase'" :href="'/compras/index/detalle/' + cc.purchase_id">{{ cc.number }}</a>
                <a v-else-if="cc.menu !== null && cc.menu['type'] === 'payorder'" :href="'/compras/detalle-orden-de-pago/' + cc.payorder_id">{{ cc.number }}</a>
                <span v-else class="data-table__muted">Pase manual</span>
              </td>
              <td class="data-table__muted">{{ cc.notes }}</td>
              <td class="text-right">{{ formatoDinamicoMoneda(cc.in) }}</td>
              <td class="text-right">{{ formatoDinamicoMoneda(cc.out) }}</td>
              <td class="text-right">
                <span class="data-table__primary" :class="cc.saldo >= 0 ? 'text-success' : 'text-danger'">
                  {{ formatoDinamicoMoneda(cc.saldo) }}
                </span>
              </td>
              <td class="text-right">
                <div class="table-action-group">
                  <button v-if="cc.purchase_id !== null" type="button" class="table-action-btn" title="Anular comprobante" @click="cancelPurchase(cc.purchase_id)">
                    <i class="bi bi-trash"></i>
                  </button>
                  <button v-if="cc.payorder_id !== null" type="button" class="table-action-btn" title="Descargar PDF" @click="getPDF(cc)">
                    <i class="bi bi-filetype-pdf"></i>
                  </button>
                  <button v-if="cc.payorder_id !== null" type="button" class="table-action-btn" title="Cancelar pago" @click="cancelPayorder(cc.id)">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="accounts.length === 0">
              <td colspan="8" class="data-table__empty">Sin movimientos</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- PAGINACION -->
      <div class="data-table__footer">
        <div class="data-table__info">
          Página {{ filters.page }} de {{ totalPages }}
        </div>
        <ul class="data-table__pagination">
          <li class="page-item" :class="{ 'disabled': filters.page === 1 }">
            <a class="page-link" href="#" @click.prevent="prevPage()">
              <i class="bi bi-chevron-left"></i>
            </a>
          </li>
          <li v-for="index in totalPages" :key="index" class="page-item" :class="{ 'active': filters.page === index }">
            <a class="page-link" href="#" @click.prevent="changePage(index)">{{ index }}</a>
          </li>
          <li class="page-item" :class="{ 'disabled': filters.page >= totalPages }">
            <a class="page-link" href="#" @click.prevent="nextPage()">
              <i class="bi bi-chevron-right"></i>
            </a>
          </li>
        </ul>
        <div class="data-table__page-size">
          <q-select v-model.number="filters.itemsPerPage" :options="itemsPerPageOptions" />
        </div>
      </div>
    </div>

    <!-- MODAL NUEVO PASE A CUENTA -->
    <NuevoPaseCuentaProveedor
      v-if="showPaseModal"
      :providerId="providerId"
      @confirmsave="onPaseSaved"
      @close="showPaseModal = false"
    />
  </div>
</template>

<script>
import Daterange from '../../global/Daterange-component.vue';
import NuevoPaseCuentaProveedor from './Nuevo-pase-cuenta-proveedor.vue';
import formatDateMixin from "../../../mixins/formatDateMixin";
import formatMoneyMixin from "../../../mixins/formatMoneyMixin";
import myaxios from 'axios';
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: { Daterange, NuevoPaseCuentaProveedor, QSelect },
  props: ['providerId'],
  mixins: [formatDateMixin, formatMoneyMixin],
  data: function () {
    return {
      loading: false,
      showPaseModal: false,
      accounts: [],
      balance: 0,
      totalPages: 1,
      provider: null,
      filters: {
        type: 0,
        fromDate: null,
        toDate: null,
        page: 1,
        itemsPerPage: 15,
      },
    };
  },
  computed: {
    typeFilterOptions() {
      return [
        { value: 0, label: 'Todos los movimientos' },
        { value: 1, label: 'Movimientos a saldar' },
        { value: 2, label: 'Movimientos saldados' },
      ];
    },
    itemsPerPageOptions() {
      return [
        { value: 15, label: '15 por página' },
        { value: 25, label: '25 por página' },
        { value: 50, label: '50 por página' },
      ];
    },
  },
  mounted() {
    this.setDefaultDateRange();
    this.getBalance();
    this.getCC();
    this.getProvider();
  },
  methods: {
    refresh() {
      this.getCC();
      this.getBalance();
    },
    onPaseSaved() {
      this.showPaseModal = false;
      this.refresh();
    },
    getBalance() {
      this.$http.get('/api/providers/getBalance/' + this.providerId)
        .then(response => {
          if (response.data.success) this.balance = response.data.data;
        })
        .catch(error => alert(error));
    },
    getCC() {
      this.$http.post('/api/providers/getAccount/' + this.providerId, this.filters)
        .then(response => {
          if (response.data.success) {
            this.accounts = response.data.data.accounts;
            this.totalPages = response.data.data.totalPages;
          } else {
            this.accounts = [];
            this.totalPages = 0;
          }
        })
        .catch(error => alert(error));
    },
    getProvider() {
      this.$http.get("/api/providers/getProvider/" + this.providerId).then((response) => {
        this.provider = response.data.data;
      });
    },
    prevPage() {
      if (this.filters.page > 1) this.filters.page -= 1;
    },
    nextPage() {
      if (this.filters.page < this.totalPages) this.filters.page += 1;
    },
    changePage(page) {
      this.filters.page = page;
    },
    cancelPurchase(id) {
      if (!confirm("¿Está seguro que desea anular este comprobante? Los comprobantes anulados pueden verse en la vista de compras")) return;
      this.$http.post("/api/purchases/cancel", { id })
        .then(response => {
          if (response.data.success) {
            this.refresh();
          } else {
            alert(response.data.message || 'No se pudo anular el comprobante.');
          }
        })
        .catch(error => alert(error));
    },
    cancelPayorder(id) {
      if (!confirm("¿Está seguro que desea eliminar este pago? Se desarmarán también todas las imputaciones en las que se encuentre asociado")) return;
      this.$http.get('/api/payments/cancelPayorder/' + id)
        .then(response => {
          if (response.data.success) {
            this.refresh();
          } else {
            alert(response.data.message || 'No se pudo cancelar el pago.');
          }
        })
        .catch(error => alert(error));
    },
    dateUpdated(date) {
      this.filters.fromDate = date.startDate;
      this.filters.toDate = date.endDate;
    },
    getPDF(cc) {
      this.$http.get('/api/payments/poPDF/' + cc.payorder_id).then(res => {
        const uninterceptedAxiosInstance = myaxios.create();
        uninterceptedAxiosInstance.get(res.data, { responseType: 'blob' }).then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = cc.id + '.pdf';
          link.click();
          URL.revokeObjectURL(link.href);
        });
      });
    },
    exportPDF() {
      this.$http.post("/api/reports/PDFdetailccp/" + this.providerId, this.filters);
    },
    ccProveedoresLink() {
      this.$router.push({ name: 'Cuenta corriente de proveedores' });
    },
    setDefaultDateRange() {
      const today = new Date();
      const startDate = new Date();
      startDate.setDate(today.getDate() - 30);
      this.filters.fromDate = this.formatDate(startDate);
      this.filters.toDate = this.formatDate(today);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${day}/${month}/${year}`;
    },
  },
  watch: {
    'filters.type'() { this.getCC(); },
    'filters.itemsPerPage'() { this.getCC(); },
    'filters.page'() { this.getCC(); },
    'filters.fromDate'() { this.getCC(); },
    'filters.toDate'() { this.getCC(); },
  },
};
</script>
